import template from "./bVersionCheck.html";

export function bVersionCheckDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    scope: {
      version: "=?"
    },
    controller: bVersionCheckController,
    controllerAs: 'bVersionCheck',
    bindToController: true
  };

  return directive;
}

class bVersionCheckController {
  constructor (VersionCheck, $interval, $scope) {
    'ngInject';

    this.VersionCheck = VersionCheck;
    this.checkVersion();
    var intervalRunning = $interval(() => {
      this.checkVersion();
    }, 20000 + Math.random() * 15000);
    $scope.$on('$destroy', function() {
      $interval.cancel(intervalRunning);
    });
  }

  checkVersion() {
    this.VersionCheck.getIndexHtml().then((success) => {
      this.index = success.data;
      let begin = this.index.indexOf("frontendVersion=\"");
      let end = this.index.indexOf("\"", begin + 17);
      this.newVersion = this.index.substring(begin + 17, end);
      this.actualVersion = window.frontendVersion;
      this.isOld = this.actualVersion != this.newVersion;
      this.version = this.actualVersion;
      this.connectionError = false;
      // REMOVE THIS SHIT
      // this.newVersion = "3.0.0";
      // END REMOVE THIS SHIT
    }, () => {
      this.connectionError = true;
    });
  }
}
